import React, { ReactNode } from 'react';
import { Space, Typography } from 'antd';

import { SaveButtonIcon } from '../features/dictionaries/DictionaryItemsList';

import { StyledButton } from './Button';
import { StyledColumn } from './StyledColumn';
import { StyledRow } from './StyledRow';

type DetailsPageHeaderProps = {
  title?: ReactNode;
  titleLevel?: 1 | 2 | 3 | 4 | 5;
  onSave?: () => void;
  onCancel?: () => void;
  actions?: ReactNode;
  children?: React.ReactNode;
};

export const DetailsPageHeader: React.FC<DetailsPageHeaderProps> = ({
  title,
  titleLevel = 3,
  onCancel,
  onSave,
  actions,
}) => {
  return (
    <StyledRow justifyContent="space-between" flexGrow="0" flexWrap="wrap">
      <StyledColumn>
        <Typography.Title level={titleLevel}>{title}</Typography.Title>
      </StyledColumn>
      <StyledColumn>
        <Space size="middle">
          {actions}
          {onCancel && <StyledButton onClick={onCancel}>Cancel</StyledButton>}
          {onSave && (
            <StyledButton type="primary" onClick={onSave} icon={<SaveButtonIcon />}>
              Save
            </StyledButton>
          )}
        </Space>
      </StyledColumn>
    </StyledRow>
  );
};
